import { render } from "./DataPrivacy.vue?vue&type=template&id=47a5565f&scoped=true"
import script from "./DataPrivacy.vue?vue&type=script&lang=js"
export * from "./DataPrivacy.vue?vue&type=script&lang=js"

import "./DataPrivacy.vue?vue&type=style&index=0&id=47a5565f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47a5565f"]])

export default __exports__